import React, { StrictMode } from "react";
import {
    Link,
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
} from "react-router-dom";

import "./assets/css/majorybl.scss";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import TestEditor from "./pages/TestEditor";
import ClubhouseRoutes from "./routes/Clubhouse";
import IndexRoutes from "./routes/Index";
import LeagueManagementRoutes from "./routes/LeagueManagement";
import LeaguesRoutes from "./routes/Leagues";
import OrgManagementRoutes from "./routes/OrgManagement";
import SiteManagementRoutes from "./routes/SiteManagement";

const App = (): React.ReactElement => {
    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route
                path="/"
                element={<Layout />}
                errorElement={<ErrorBoundary />}
                handle={{ crumb: () => <Link to="/">Home</Link> }}
            >
                {IndexRoutes}
                {LeaguesRoutes}
                {ClubhouseRoutes}
                {LeagueManagementRoutes}
                {OrgManagementRoutes}
                {SiteManagementRoutes}
                {process.env.BUILD_ENV === "development" && (
                    <Route element={<RequireAuth allowedUserLevels={[1]} />}>
                        <Route path="testeditor" element={<TestEditor />} />
                    </Route>
                )}
            </Route>,
        ),
    );

    return (
        <StrictMode>
            <RouterProvider router={router} />
        </StrictMode>
    );
};

export default App;
